import React, { useEffect, useState } from "react";
import binanceLogo from "../../images/binanceLogo.png";
import bitfinexLogo from "../../images/bitfinexLogo.png";
import bitmexLogo from "../../images/bitmexLogo.png";
import okxLogo from "../../images/okxLogo.png";
import bybitLogo from "../../images/bybitLogo.png";
import coinbaseLogo from "../../images/coinbase.png";
import kucoinLogo from "../../images/kucoin.png";
import api from "../../api";
import { Loader } from "../global/loader";
import moment from "moment";

const exchangeList = [
  {
    exchange: "binance",
    icon: binanceLogo,
  },
  {
    exchange: "coinbase_pro",
    icon: coinbaseLogo,
  },
  {
    exchange: "okx",
    icon: okxLogo,
  },
  {
    exchange: "bybit",
    icon: bybitLogo,
  },
  {
    exchange: "kucoin",
    icon: kucoinLogo,
  },
  {
    exchange: "bitmex",
    icon: bitmexLogo,
  },
];

export const WhaleTrades = () => {
  const [selectedExchange, setSelectedExchange] = useState("binance");
  const [LiquidationData, setLiquidationData] = useState([]);
  const [loader, setLoader] = useState(true);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const getWTrades = async () => {
    try {
      let payload = {
        exchange: selectedExchange,
      };
      setLoader(true);
      const resp = await api.getWhaleTrades(payload);
      // console.log(resp);
      if (resp?.data) {
        setLiquidationData(resp?.data);
      }
      setLoader(false);
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getWTrades();
  }, [selectedExchange]);

  const getIconSource = (exname) => {
    // find the matching exchange
    const selected = exchangeList.find((ex) => ex.exchange === exname);

    // get its icon (or fallback if not found)
    const selectedIcon = selected ? selected.icon : null;
    return selectedIcon;
  };

  return (
    <div className="liquidityMain">
      <div className="selectCoin">
        <h5 className="me-2">Whale Trades</h5>

        <div className="expand">
          <button
            className=" dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src={getIconSource(selectedExchange)}
              alt="icon"
              width={"27px"}
              style={{ marginRight: 10 }}
            />
            {selectedExchange}
          </button>
          <ul className="dropdown-menu">
            <div className="coinSelector">
              {exchangeList.map((item, key) => (
                <div
                  className="coin"
                  onClick={() => setSelectedExchange(item.exchange)}
                  key={key}
                >
                  <img
                    loading="lazy"
                    width="20"
                    src={`${item?.icon}`}
                    srcSet={`${item?.icon}`}
                    alt=""
                  />
                  <div className="name">{item.exchange}</div>
                </div>
              ))}
            </div>
          </ul>
        </div>
      </div>
      <div className="descrip mb-2">
        Data on executed large trades made by whales. Investors who make large
        trades that can significantly impact the market. Provides valuable
        insights into market trends and investor behavior.
      </div>

      <Table data={LiquidationData || []} />

      {loader && <Loader />}
    </div>
  );
};

const Table = ({ data }) => {
  function formatNumber(num) {
    const isNegative = num < 0;
    const absNum = Math.abs(num);

    let formatted;
    if (absNum >= 1_000_000_000) {
      formatted = (absNum / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (absNum >= 1_000_000) {
      formatted = (absNum / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (absNum >= 1_000) {
      formatted = (absNum / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      formatted = absNum.toString();
    }

    return isNegative ? `-${formatted}` : formatted;
  }

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent pt-0 px-0 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="sticky-col-head">
                    Name
                  </th>
                  <th scope="col" className="">
                    Exchange
                  </th>
                  <th scope="col" className="">
                    Quantity
                  </th>
                  <th scope="col" className="">
                    Total
                  </th>
                  <th scope="col" className="">
                    Side
                  </th>
                  <th scope="col" className="">
                    Date/Time
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td scope="row" className="sticky-col">
                      <div className="table-text-dark w-max-c db">
                        {item?.pair}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db text-capitalize">
                        {item?.exchange}
                      </div>
                    </td>
                    <td scope="row">
                      <div className=" w-max-c db">
                        {formatNumber(item?.size || 0)}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="w-max-c db ">
                        {formatNumber(item?.total || 0)}{" "}
                        {item?.pair.split("-")[1]}
                      </div>
                    </td>
                    <td scope="row">
                      {item?.side == "BUY" || item?.side == "buy" ? (
                        <span class="badge bg-success">{item?.side}</span>
                      ) : (
                        <span class="badge bg-danger">{item?.side}</span>
                      )}
                    </td>
                    <td scope="row">{moment(item?.timestamp).fromNow()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
